import { useQuery } from '@tanstack/react-query';

import { fetchGlobalApprovalsApi } from './api';
import { GlobalApprovalsParams } from './GlobalApprovals.types';

/*
 * One page at a time, straight from GLOBAL. A page is kept for a minute so
 * going back and forth between pages does not ask again each time.
 */
export default function useGlobalApprovalsQuery(params: GlobalApprovalsParams) {
  return useQuery(['healthClaims', 'approvals', params], fetchGlobalApprovalsApi, {
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
